import { render, staticRenderFns } from "./EditStoreSettings.vue?vue&type=template&id=36773024"
import script from "./EditStoreSettings.vue?vue&type=script&lang=js"
export * from "./EditStoreSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports